const HTTP_CODE_STATUS = {
  /**40001未登录 40002token失效 40010账号被异地登录 40011token来源异常*/
  INVALID: [40001, 40002, 40010],
  NOAUTH: [40011],
  /**成功状态 */
  SUCCESS: 1,
  /**返回时间状态 */
  TIME_BACK_STATUS: 50023
}
export default Object.freeze(HTTP_CODE_STATUS)
